import { render, staticRenderFns } from "./BackdropFiles.vue?vue&type=template&id=317c3628"
import script from "./BackdropFiles.vue?vue&type=script&lang=js"
export * from "./BackdropFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports